export default __webpack_public_path__ + "static/media/apple-mail.d414f3d5.svg";